export default __webpack_public_path__ + "ca799c89142e9bea2a963d6c537c0489.png";